import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/link-context';
import { createUploadLink } from 'apollo-upload-client';

import config from '../config';

const PRODUCTION_API = 'https://bag-api-production.herokuapp.com/graphql';
const STAGING_API = 'https://bag-api-staging.herokuapp.com/graphql';

export const CURRENT_URL =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_STAGING_APP !== 'true'
    ? PRODUCTION_API
    : STAGING_API;

const cache = new InMemoryCache();

const authLink = setContext((_, { headers }) => {
  const token = sessionStorage.getItem(config.tokenKey);

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const uploadLink = createUploadLink({
  uri: CURRENT_URL,
});

const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

export default client;
